/**
 * FILE: apps/hub/src/components/OnboardingShell.tsx
 * PURPOSE: Branded full-screen shell for auth and onboarding flows.
 * AGENT_CONTEXT: Replaces inline LoginBrandedShell and AuthLayout duplication.
 */

import type { HTMLAttributes, ReactNode } from 'react'

import { cn } from '@/lib/utils'

export interface OnboardingShellProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode
  contentClassName?: string
}

export function OnboardingShell({
  children,
  className,
  contentClassName,
  ...rest
}: OnboardingShellProps) {
  return (
    <div className={cn('relative min-h-screen overflow-hidden bg-background', className)} {...rest}>
      <div
        className={cn(
          'relative z-[1] flex min-h-screen items-center justify-center px-4 py-12',
          contentClassName,
        )}
      >
        {children}
      </div>
    </div>
  )
}
